type IFeatureItem = {
  title: string;
  description?: string;
  image?: string;
};

export const AUDIT_REPORT_URL =
  "https://github.com/pitfidev/pit-contracts/tree/main/audits";

export const APP_FEATURES: IFeatureItem[] = [
  {
    title: "Stake",
    description: "Deposit your tokens into Pit Vaults",
  },
  {
    title: "Earn",
    description:
      "Earn yield and PIT POINTS!",
  },
  {
    title: "Auto compound",
    description:
      "Pit automates and repeats the process, saving you time and fees",
  },
];

export const SUPPORTED_TOKENS: (IFeatureItem & {
  color: string;
  textColor?: string;
  lightTextColor?: string;
  lightColor?: string;
})[] = [
  {
    title: "USDC.n",
    image: "/icons/tokens/USDC.n.svg",
    color: "#C06659",
    lightColor: "#C06659",
    textColor: "#060606",
    lightTextColor: "#FFFFFF",
  },
  {
    title: "USDT",
    image: "/icons/tokens/png/usdt.png",
    color: "#4A8587",
    lightColor: "#4A8587",
    textColor: "#060606",
    lightTextColor: "#FFFFFF",
  },
  {
    title: "SEI",
    image: "/icons/tokens/png/sei.png",
    color: "#ECCC74",
    lightColor: "#ECCC74",
    textColor: "#FFFFFF",
    lightTextColor: "#1A1A1A",
  },
  {
    title: "iSEI",
    image: "/icons/tokens/png/isei.png",
    color: "#282828",
    lightColor: "#EDEDED",
    textColor: "#FFFFFF",
    lightTextColor: "#1A1A1A",
  },
];

export type FooterMenuItem = {
  title: string;
  href: string;
  isExternal?: boolean;
};

export type FooterMenuGroup = {
  title: string;
  items: FooterMenuItem[];
};

export type FooterSocialItem = {
  icon: string;
  href: string;
};

export const FOOTER_SOCIAL_ITEMS: FooterSocialItem[] = [
  { icon: "/icons/socials/twitter.svg", href: "https://x.com/pit_finance" },
  { icon: "/icons/socials/telegram.svg", href: "https://t.me/pitfinance" },
  {
    icon: "/icons/socials/github.svg",
    href: "https://github.com/pitfidev/pit-contracts",
  },
];

export const FOOTER_MENU_GROUPS: FooterMenuGroup[] = [
  {
    title: "Products",
    items: [
      { title: "Press Kit", href: "/press-kit" },
      {
        title: "Audit",
        href: AUDIT_REPORT_URL,
        isExternal: true,
      },
      // { title: "FIT tokens", href: "/fit-tokens" },
    ],
  },
  {
    title: "Resources",
    items: [
      { title: "Docs", href: "https://docs.pit.finance/", isExternal: true },
      {
        title: "FAQs",
        href: "https://docs.pit.finance/faqs/general",
        isExternal: true,
      },
      { title: "Contact Us", href: "mailto:contact@pit.finance" },
    ],
  },
  // {
  //   title: "Information",
  //   items: [
  //     { title: "About us", href: "/about" },
  //     { title: "Contact Us", href: "/contact-us" },
  //     { title: "Privacy Notice", href: "/privacy-notice" },
  //     { title: "Terms Of Use", href: "/terms-of-use" },
  //   ],
  // },
];
